export const StandardGameRoundColumns = [
  { header: 'none', columnDef: 'editInMobileView' },
  { header: 'Question Type', columnDef: 'question_type' },
  { header: 'Point Value', columnDef: 'point_value' },
  { header: 'Category', columnDef: 'category' },
  { header: 'Sub Category', columnDef: 'sub_category' },
  { header: 'Questions', columnDef: 'questions' },
  { header: 'Answer', columnDef: 'answer' },
  { header: 'Answer Type', columnDef: 'answer_type' },
  { header: 'none', columnDef: 'actions' },
  { header: 'Report Question', columnDef: 'flag' },
];
